import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AssistanceApplicationReviewService} from '../../../../../../services/assistance-application-review.service';

@Component({
    selector: 'app-pass-review-agency',
    templateUrl: './pass-review-agency.component.html',
    styleUrls: ['./pass-review-agency.component.scss'],
    standalone: false
})
export class PassReviewAgencyComponent implements OnInit{
    public form: FormGroup;
    public isProcessing = false;

    constructor(private _reviewService: AssistanceApplicationReviewService, private fb: FormBuilder) {
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            additionalInformation: this.fb.control('', this.requireAdditionalInfo ? [Validators.required] : [])
        });
    }

    @Input() assistanceApplicationId: string;
    @Input() requireAdditionalInfo: boolean;
    @Input() additionalInfoLabel: string = 'Notes';
    @Output() closeModal = new EventEmitter();

    public get additionalInformation(): FormControl {
        return this.form.get('additionalInformation') as FormControl;
    }

    onClickCancel(): void {
        this.additionalInformation.reset();
        this.closeModal.emit();
    }

    onClickConfirmPass(): void {
        if (this.isProcessing) {
            return;
        }
        if (this.requireAdditionalInfo && !this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        this.isProcessing = true;
        this._reviewService.passAgencyReviewApplication(this.assistanceApplicationId, this.requireAdditionalInfo ? this.additionalInformation.value : undefined)
            .subscribe({
                next: () => {
                    this.additionalInformation.reset();
                    this.isProcessing = false;
                    this.closeModal.emit();
                    window.location.reload();
                },
                error: (err) => {
                    console.error(err)
                    this.isProcessing = false;
                }
            });
    }
}
